/**
 * Information on attentive pixel SDK and event properties can be found at:
 * https://docs.attentive.com/pages/developer-guides/sdks/attentive-tag-sdk/#attentive-tag-sdk
 */
import { __decorate } from "tslib";
import { _Memo, loadScript } from '@naturalcycles/js-lib';
class AttentiveClient {
    constructor() {
        /**
         * More information on the attentive pixel can be found here:
         * https://help.attentivemobile.com/hc/en-us/articles/10905920909460-The-Attentive-tag#h_01J9PJ9S9WMZBAGC8DBKQK328Z
         */
        this.pixelId = 'N/A';
    }
    /**
     * @description Idempotent function. Runs attentive pixel code.
     * Attention: The script needs to be loaded from cdn, since it will
     * change depending on users geolocation.
     */
    async attentivePixel() {
        await loadScript('https://cdn.attn.tv/naturalcycles/dtag.js');
    }
    load() {
        void this.attentivePixel();
    }
    pageView() {
        this.sendEvent(AnalyticsEvent.pageView);
    }
    lead({ hashedPhone, hashedEmail }) {
        // https://docs.attentive.com/pages/developer-guides/sdks/attentive-tag-sdk/#identify
        this.sendEvent(AnalyticsEvent.identify, { phone: hashedPhone, email: hashedEmail });
    }
    addToCart({ id, amount, currency, plan, hashedEmail, hashedPhone, }) {
        // https://docs.attentive.com/pages/developer-guides/sdks/attentive-tag-sdk/#add-to-cart
        this.sendEvent(AnalyticsEvent.addToCart, {
            items: [
                {
                    name: plan,
                    price: { value: amount, currency },
                },
            ],
            order: { orderId: id },
            user: { email: hashedEmail, phone: hashedPhone },
        });
    }
    purchase({ id, amount, currency, plan, hashedEmail, hashedPhone }) {
        // https://docs.attentive.com/pages/developer-guides/sdks/attentive-tag-sdk/#purchase
        this.sendEvent(AnalyticsEvent.purchase, {
            items: [
                {
                    name: plan,
                    price: { value: amount, currency },
                },
            ],
            order: { orderId: id },
            user: { email: hashedEmail, phone: hashedPhone },
        });
    }
    sendEvent(eventName, data = {}) {
        void this.attentivePixel().then(() => {
            window.attentive.analytics[eventName](data);
        });
    }
}
__decorate([
    _Memo()
], AttentiveClient.prototype, "attentivePixel", null);
export const attentiveClient = new AttentiveClient();
var AnalyticsEvent;
(function (AnalyticsEvent) {
    AnalyticsEvent["pageView"] = "pageView";
    AnalyticsEvent["addToCart"] = "addToCart";
    AnalyticsEvent["identify"] = "identify";
    AnalyticsEvent["purchase"] = "purchase";
})(AnalyticsEvent || (AnalyticsEvent = {}));
